<template>
  <div id="page-container">
    <component :is="currentContainer">
      <router-view v-if="isRouterAlive" />
    </component>
  </div>
</template>

<script setup lang="ts">
import { isMobile } from "@common_lib/base/utils/src/tools"
import { sendMessage } from "@/composables/useBridge"
import { safeLocalStorage, safeSessionStorage } from "@/utils/safeStorage"

const googleAnalytics = useGoogleAnalytics()

useModalStore()
useNavbarStore()

useFraudProtectionSystem()
useReceiveMessage()
useWebsiteErrorRedirect()

// PostMessage 處理 iframe 關閉訊息
const { handleIframeCloseQuery } = usePostMessage()
handleIframeCloseQuery()

const {
  shouldLoadJBLScript,
  hasMountedJBL,
  loadJBLScript,
  initJBLWebSocket,
  fetchRecommendLine
} = useJBLWebSocket()

useChangeLine({
  shouldLoadJBLScript,
  hasMountedJBL,
  loadJBLScript,
  initJBLWebSocket,
  fetchRecommendLine
})

useChat()

const components = {
  MobileContainer: defineAsyncComponent(() => import("@/layouts/mobile/Container.vue")),
  DesktopContainer: defineAsyncComponent(() => import("@/layouts/desktop/Container.vue"))
}

const currentContainer = computed(() =>
  isMobile() ? components.MobileContainer : components.DesktopContainer
)

const websiteInfoStore = useWebsiteInfoStore()
const { isRouterAlive, state } = storeToRefs(websiteInfoStore)
const authStore = useAuthStore()
const { isLogin } = storeToRefs(authStore)
const { fetchAccountTracker } = useFetchAccountTracker()
const { fetchFingerprintPro } = useFetchFingerprintPro()

// 一般登入(含 half-login)的 tracking 已移到 useFetchLogin 的 login()／demoLogin()，
// 在登入成功的當下直接打。這裡只負責 API 白牌：使用者帶 URL queryPass 進來、不走
// 登入表單，因此在 App 掛載時補打一次。lastTrackedQueryPass 去重，避免同一個白牌
// session 重新整理頁面時重複打。
const LAST_TRACKED_QUERY_PASS_KEY = "lastTrackedQueryPass"
const urlQueryPass = safeSessionStorage.getItem("urlQueryPass")

const trackWhiteLabelSession = () => {
  if (!urlQueryPass) return
  if (urlQueryPass === safeLocalStorage.getItem(LAST_TRACKED_QUERY_PASS_KEY)) return
  safeLocalStorage.setItem(LAST_TRACKED_QUERY_PASS_KEY, urlQueryPass)
  fetchAccountTracker().catch(err =>
    console.error("[App] accountTracker API failed", err)
  )
  fetchFingerprintPro().catch(err =>
    console.error("[App] fingerprintPro API failed", err)
  )
}

useBridge()

onMounted(() => {
  trackWhiteLabelSession()

  googleAnalytics.initialize()

  /**
   * APP 橋接
   */
  if (state.value.isMobileAppActive) {
    const cricketUrl = `${window.location.origin}/#/?AppHomeBtn=true`
    sendMessage(
      JSON.stringify({
        sessionId: state.value.queryPass,
        platform: "cricket",
        cricketUrl
      })
    )
    sendMessage(JSON.stringify({ isShowHomeButton: "true" }))

    if (isLogin.value) {
      sendMessage(`{"userId":"${state.value.userID}"}`)
    }
  }
})
</script>

<style lang="scss" scoped></style>
